import { useLocation, Navigate } from "react-router-dom";
import routes from "../constants/routes";
import { getCookie, USER_COOKIE } from './cookie-service';

export function PrivateRoute({ children }) {
    const auth = getCookie(USER_COOKIE);
    const location = useLocation();

    if (!auth) {
        return <Navigate to={routes.login} state={{ from: location }} />;
    }

    return children;
}